
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SubSidebar',
  props: {
    stickyTop: {
      type: String,
      default: '0px'
    },
    stickyHeight: {
      type: String,
      default: '100vh'
    }
  }
})
